import type { ReactNode } from 'react'

import { Navbar } from '@/layout/navbar/Navbar'

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <Navbar />
      {children}
    </>
  )
}
